// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#modalResult .body {
  overflow: visible;
  overflow: initial;
}
#modalResult .body .content {
  display: grid;
  grid-template-columns: 100px 1fr 100px;
  grid-template-rows: 1fr;
  -webkit-box-align: normal;
      -ms-flex-align: normal;
          align-items: normal;
}
@media screen and (max-width: 720px) {
  #modalResult .body .content {
    grid-template-columns: 1fr;
  }
}
#modalResult .user-cards {
  margin: -15px 0px -15px -15px;
  width: 100px;
  position: relative;
  -webkit-box-shadow: inset -7px -7px 14px 0px hsla(0, 0%, 0%, 0.33);
          box-shadow: inset -7px -7px 14px 0px hsla(0, 0%, 0%, 0.33);
  border-radius: 5px 0 0 0;
}
#modalResult .user-cards .cards-mask {
  position: absolute;
  top: -25px;
  right: 0;
  bottom: 0;
  left: -110px;
  overflow: hidden;
}
#modalResult .user-cards .card {
  position: absolute;
  bottom: 0;
  right: 0;
}
#modalResult .user-cards .card:first-child {
  z-index: 100;
  -webkit-transform: rotate(-15deg) translate(5px, 50px);
          transform: rotate(-15deg) translate(5px, 50px);
}
#modalResult .user-cards .card:nth-child(2) {
  z-index: 10;
  -webkit-transform: rotate(-196deg) translate(25px, 5px);
          transform: rotate(-196deg) translate(25px, 5px);
}
#modalResult .opponent-cards {
  margin: -15px 0px -15px 15px;
  width: 100px;
  position: relative;
  -webkit-box-shadow: inset 7px -7px 14px 0px hsla(0, 0%, 0%, 0.33);
          box-shadow: inset 7px -7px 14px 0px hsla(0, 0%, 0%, 0.33);
  border-radius: 0 5px 0 0;
}
#modalResult .opponent-cards .cards-mask {
  position: absolute;
  top: -25px;
  right: -105px;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
#modalResult .opponent-cards .card {
  position: absolute;
  bottom: 0;
  left: 0;
}
#modalResult .opponent-cards .card:first-child {
  z-index: 100;
  -webkit-transform: rotate(10deg) translate(5px, 50px);
          transform: rotate(10deg) translate(5px, 50px);
}
#modalResult .opponent-cards .card:nth-child(2) {
  z-index: 10;
  -webkit-transform: rotate(-170deg) translate(-25px, 5px);
          transform: rotate(-170deg) translate(-25px, 5px);
}
@media screen and (max-width: 720px) {
  #modalResult .user-cards,
  #modalResult .opponent-cards {
    display: none;
  }
}
#modalResult .green-cards {
  background: var(--green);
}
#modalResult .red-cards {
  background: var(--red);
}
#modalResult .result {
  font-size: 1.7em;
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 10px 0;
  border: 1px solid rgba(0, 0, 0, 0.25);
  width: 100%;
  text-align: center;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  border-radius: 5px;
}
#modalResult .result.green {
  color: green;
}
#modalResult .result.red {
  color: red;
}
#modalResult table {
  font-size: 12px;
}
#modalResult .result-table {
  padding: 8px 4px 4px 8px;
  background: rgb(223, 223, 223);
  border-radius: 5px;
  margin-bottom: 10px;
}
#modalResult .result-table td,
#modalResult .result-table th {
  padding: 0 8px 8px 0;
  text-align: center;
  -webkit-font-feature-settings: "tnum";
          font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
#modalResult .result-table tbody tr:nth-child(1) td:nth-child(1),
#modalResult .result-table tbody tr:nth-child(2) td:nth-child(1) {
  text-align: left;
}
#modalResult .result-table tbody tr:nth-child(1) td:nth-child(1):before,
#modalResult .result-table tbody tr:nth-child(2) td:nth-child(1):before {
  content: "";
  display: inline-block;
  height: 13px;
  width: 13px;
  border-radius: 20%;
  margin-right: 5px;
  margin-bottom: -2px;
}
#modalResult .result-table tbody tr.red td:nth-child(1):before {
  background-color: var(--red);
}
#modalResult .result-table tbody tr.green td:nth-child(1):before {
  background-color: var(--green);
}
#modalResult .result-table tr.winner td:nth-child(1),
#modalResult .result-table tr.winner td:last-child {
  font-weight: bolder;
}
#modalResult .result-table tbody tr {
  font-size: 1.24em;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modalResult.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EAAA,iBAAA;AAAJ;AAEI;EACE,aAAA;EACA,sCAAA;EACA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAAN;AAEM;EANF;IAOI,0BAAA;EACN;AACF;AAGE;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,kEAAA;UAAA,0DAAA;EACA,wBAAA;AADJ;AAGI;EACE,kBAAA;EACA,UAAA;EAAA,QAAA;EAAA,SAAA;EAAA,YAAA;EACA,gBAAA;AADN;AAII;EACE,kBAAA;EACA,SAAA;EACA,QAAA;AAFN;AAIM;EACE,YAAA;EACA,sDAAA;UAAA,8CAAA;AAFR;AAKM;EACE,WAAA;EACA,uDAAA;UAAA,+CAAA;AAHR;AAQE;EACE,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,iEAAA;UAAA,yDAAA;EACA,wBAAA;AANJ;AAQI;EACE,kBAAA;EACA,UAAA;EAAA,aAAA;EAAA,SAAA;EAAA,OAAA;EACA,gBAAA;AANN;AASI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AAPN;AASM;EACE,YAAA;EACA,qDAAA;UAAA,6CAAA;AAPR;AAUM;EACE,WAAA;EACA,wDAAA;UAAA,gDAAA;AARR;AAaE;EACE;;IAEE,aAAA;EAXJ;AACF;AAcE;EACE,wBAAA;AAZJ;AAeE;EACE,sBAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;UAAA,uBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,YAAA;AAdN;AAiBI;EACE,UAAA;AAfN;AAmBE;EACE,eAAA;AAjBJ;AAoBE;EACE,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAlBJ;AAoBI;;EAEE,oBAAA;EACA,kBAAA;EACA,qCAAA;UAAA,6BAAA;EAAA,kCAAA;AAlBN;AAqBI;;EAEE,gBAAA;AAnBN;AAqBM;;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAlBR;AAsBI;EACE,4BAAA;AApBN;AAuBI;EACE,8BAAA;AArBN;AAwBI;;EAEE,mBAAA;AAtBN;AAyBI;EACE,iBAAA;AAvBN","sourcesContent":["#modalResult {\n  .body {\n    overflow: initial;\n\n    .content {\n      display: grid;\n      grid-template-columns: 100px 1fr 100px;\n      grid-template-rows: 1fr;\n      align-items: normal;\n\n      @media screen and (max-width: 720px) {\n        grid-template-columns: 1fr;\n      }\n    }\n  }\n\n  .user-cards {\n    margin: -15px 0px -15px -15px;\n    width: 100px;\n    position: relative;\n    box-shadow: inset -7px -7px 14px 0px hsl(0deg 0% 0% / 33%);\n    border-radius: 5px 0 0 0;\n\n    .cards-mask {\n      position: absolute;\n      inset: -25px 0 0 -110px;\n      overflow: hidden;\n    }\n\n    & .card {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n\n      &:first-child {\n        z-index: 100;\n        transform: rotate(-15deg) translate(5px, 50px);\n      }\n\n      &:nth-child(2) {\n        z-index: 10;\n        transform: rotate(-196deg) translate(25px, 5px);\n      }\n    }\n  }\n\n  .opponent-cards {\n    margin: -15px 0px -15px 15px;\n    width: 100px;\n    position: relative;\n    box-shadow: inset 7px -7px 14px 0px hsl(0deg 0% 0% / 33%);\n    border-radius: 0 5px 0 0;\n\n    .cards-mask {\n      position: absolute;\n      inset: -25px -105px 0 0;\n      overflow: hidden;\n    }\n\n    & .card {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n\n      &:first-child {\n        z-index: 100;\n        transform: rotate(10deg) translate(5px, 50px);\n      }\n\n      &:nth-child(2) {\n        z-index: 10;\n        transform: rotate(-170deg) translate(-25px, 5px);\n      }\n    }\n  }\n\n  @media screen and (max-width: 720px) {\n    .user-cards,\n    .opponent-cards {\n      display: none;\n    }\n  }\n\n  .green-cards {\n    background: var(--green);\n  }\n\n  .red-cards {\n    background: var(--red);\n  }\n\n  .result {\n    font-size: 1.7em;\n    margin-top: 15px;\n    margin-bottom: 10px;\n    padding: 10px 0;\n    border: 1px solid rgb(0, 0, 0, 25%);\n    width: 100%;\n    text-align: center;\n    box-sizing: content-box;\n    border-radius: 5px;\n\n    &.green {\n      color: green;\n    }\n\n    &.red {\n      color: red;\n    }\n  }\n\n  table {\n    font-size: 12px;\n  }\n\n  .result-table {\n    padding: 8px 4px 4px 8px;\n    background: rgb(223, 223, 223);\n    border-radius: 5px;\n    margin-bottom: 10px;\n\n    td,\n    th {\n      padding: 0 8px 8px 0;\n      text-align: center;\n      font-variant-numeric: tabular-nums;\n    }\n\n    tbody tr:nth-child(1) td:nth-child(1),\n    tbody tr:nth-child(2) td:nth-child(1) {\n      text-align: left;\n\n      &:before {\n        content: '';\n        display: inline-block;\n        height: 13px;\n        width: 13px;\n        border-radius: 20%;\n        margin-right: 5px;\n        margin-bottom: -2px;\n      }\n    }\n\n    tbody tr.red td:nth-child(1):before {\n      background-color: var(--red);\n    }\n\n    tbody tr.green td:nth-child(1):before {\n      background-color: var(--green);\n    }\n\n    tr.winner td:nth-child(1),\n    tr.winner td:last-child {\n      font-weight: bolder;\n    }\n\n    tbody tr {\n      font-size: 1.24em;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
